window.CKEDITOR.on('instanceLoaded', () => {
  // Editing the CKEditor DTD here: https://ckeditor.com/docs/ckeditor4/latest/api/CKEDITOR_dtd.html
  // This should be fine, since this is valid HTML5
  window.CKEDITOR.dtd.a.div = 1;
  window.CKEDITOR.dtd.div.link = 1;
  // This one is a little more risky, because this IS NOT valid HTML5
  // Shame on the Riddle developers!!
  window.CKEDITOR.dtd.iframe.section = 1;
});
